import * as Yup from "yup";

// const validation = "^[A-Z]{3}-[A-Z]{6}-[A-Z0-9]{3}-\\d{4}-\\d{6}$";

const validationSchema = (companyObject: any) =>
  Yup.object({
    party: Yup.object().required("Party is required"),

    orderNumber: Yup.string()
      .required("Order Number is required.")
      .test(
        "companyCheck",
        `Order number is invalid and should be in the format(${companyObject?.orderNumberExample})`,
        function (value) {
          const regexPattern = companyObject?.orderNumberFormat;
          const regex = new RegExp(regexPattern);
          return regex.test(value);
        },
      ),

    date: Yup.string().required("Date is required"),
    orderAmount: Yup.string().required("Order Amount is required"),
    lineItem: Yup.string().required("Line Item is required"),
    VOR: Yup.boolean(),
    U: Yup.boolean(),
  });

export { validationSchema };
